import ChecklistView from "@/views/cheklist/ChecklistView";
import ChecklistId from "@/views/cheklist/checklist-id/ChecklistId";
import Inspection from "@/views/inspections/components/inspection/Inspection";
import { createBrowserRouter } from "react-router";
import InspectionsLists from "@/views/inspections/components/inspections-lists/InspectionsLists";
import { BASE_URL } from "@/assets/constants/constants";
import Unauthorized from "@/views/error/Unauthorized";
import NotFound from "@/views/error/NotFound";
import Layout from "@/layout/Layout";
import AppAuthWithErrorBoundary from "@/views/error/AppAuthWithErrorBoundary";
import RouterErrorBoundary from "@/views/error/RouterErrorBoundary";

const router = createBrowserRouter([
  {
    path: BASE_URL,
    Component: AppAuthWithErrorBoundary,
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        path: "",
        Component: Layout,
        children: [
          {
            index: true,
            Component: InspectionsLists,
          },
          {
            path: ":inspectionId",
            Component: Inspection,
          },
          {
            path: "checklist",
            children: [
              {
                index: true,
                Component: ChecklistView,
              },
              {
                path: ":checklistId",
                Component: ChecklistId,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "unauthorized",
    Component: Unauthorized,
  },
  {
    path: `*`,
    Component: NotFound,
  },
]);

export default router;
